export default "__VITE_ASSET__CyG4bdqz__"